import { CoreApi } from '../services';

export const coreApi = new CoreApi();
